import moment from "moment";
import React, { useState } from "react";

function DualCalendar({ selectedDate, handleDateClick }) {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const myZone = localStorage.getItem("zone") || "UTC";

  const getCurrentDateInZone = () => {
    const zonedDate = moment().tz(myZone);
    return new Date(zonedDate.year(), zonedDate.month(), zonedDate.date());
  };

  const handlePrevMonth = () => {
    setCurrentMonth(prevMonth(currentMonth));
  };

  const handleNextMonth = () => {
    setCurrentMonth(nextMonth(currentMonth));
  };

  const prevMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
  };

  const nextMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 1);
  };

  const renderCalendar = (date) => {
    const days = [];
    const weekdays = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const daysInMonth = lastDayOfMonth.getDate();
    let startingDay = firstDayOfMonth.getDay();
    startingDay = startingDay === 0 ? 6 : startingDay - 1;

    weekdays.forEach((day) => {
      days.push(
        <div key={day} className="weekday-header">
          {day}
        </div>
      );
    });

    for (let i = 0; i < startingDay; i++) {
      days.push(<div key={`prev-${i}`} className="day empty"></div>);
    }

    for (let i = 0; i < daysInMonth; i++) {
      const currentDate = moment
        .tz([date.getFullYear(), date.getMonth(), i + 1], myZone || "UTC")
        .toDate();
      const today = getCurrentDateInZone();
      const isPastDate = moment(currentDate)
        .tz(myZone || "UTC")
        .isBefore(moment(today).tz(myZone || "UTC"), "day");

      const isSaturday = currentDate.getDay() === 6;
      const isSunday = currentDate.getDay() === 0;

      days.push(
        <div
          key={currentDate}
          className={`day ${
            selectedDate &&
            currentDate.toDateString() === selectedDate.toDateString()
              ? "selected"
              : ""
          } ${isPastDate ? "disabled" : ""} ${
            isSaturday || isSunday ? "weekend" : ""
          }`}
          onClick={() => (isPastDate ? null : handleDateClick(currentDate))}
        >
          {i + 1}
        </div>
      );
    }

    return <div className="calendar">{days}</div>;
  };

  const isSameDay = (date1, date2) => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };

  return (
    <div className="dual-calendar">
      <div className="month-nav">
        <button
          className="btn btn-primary btn-reel rounded-pill"
          onClick={handlePrevMonth}
        >
          Prev
        </button>

        <button
          className="btn btn-primary btn-reel rounded-pill"
          onClick={handleNextMonth}
        >
          Next
        </button>
      </div>
      <div className="flex-calendar">
        <div className="calendar-container d-none-mob">
          {" "}
          <span className="d-block text-center">
            {currentMonth.toLocaleString("default", {
              month: "long",
              year: "numeric",
            })}
          </span>
          {renderCalendar(currentMonth)}
        </div>
        <div className="calendar-container">
          <span className="d-block text-center">
            {nextMonth(currentMonth).toLocaleString("default", {
              month: "long",
              year: "numeric",
            })}
          </span>
          {renderCalendar(nextMonth(currentMonth))}
        </div>
      </div>
    </div>
  );
}

export default DualCalendar;
